import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsyncContentManagerService } from '@services';
import { Logger } from '@utils/logger';
import { Observable } from 'rxjs';

const logger = Logger.getLogger('FundApiInterceptors');

@Injectable()
export class FundApiInterceptor implements HttpInterceptor {
  constructor(private acm: AsyncContentManagerService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.indexOf('/pds-graphql/') !== -1) {
      request = request.clone({
        withCredentials: false,
        headers: new HttpHeaders({
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }),
      });

      this.acm.addRequest(request);
      return new Observable((observer) => {
        const subscription = next.handle(request).subscribe(
          (event) => {
            if (event instanceof HttpResponse) {
              this.acm.removeRequest(request);
              observer.next(event);
            }
          },
          (err) => {
            logger.error(
              'fund API error while getting pds-graphql: ' + request
            );
            this.acm.removeRequest(request);
            observer.error(err);
          },
          () => {
            // this.removeRequest(request);
            observer.complete();
          }
        );
        // remove request from queue when cancelled
        return () => {
          // this.removeRequest(request);
          subscription.unsubscribe();
        };
      });
    } else {
      return next.handle(request);
    }
  }
}
